module.exports = __webpack_public_path__ + "static/media/1-2.c6136477.mp3";